import React from 'react';
import { ZoomContainer, ZoomButton, ZoomFactor } from './styles';

const ZoomControls = ({ zoomFactor, onZoomIn, onZoomOut, onReset }) => (
  <ZoomContainer>
    <ZoomButton onClick={() => onZoomIn(true)} disabled={zoomFactor >= 10}>
      <span>⊕</span>
    </ZoomButton>
    <ZoomButton onClick={() => onZoomIn(false)} disabled={zoomFactor >= 10}>
      <span>+</span>
    </ZoomButton>
    <ZoomFactor>
      {Math.round(zoomFactor * 100)}%
    </ZoomFactor>
    <ZoomButton onClick={onZoomOut} disabled={zoomFactor <= 0.5}>
      <span>-</span>
    </ZoomButton>
    <ZoomButton onClick={onReset} disabled={zoomFactor === 1}>
      <span>⌖</span>
    </ZoomButton>
  </ZoomContainer>
);

export default ZoomControls; 
